module.exports = {
      id: "marginnote-more-4-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "images/js_src_vue/page_marginnote_landing/sprite.20f12c2e.svg#marginnote-more-4-usage",
      toString: function () {
        return this.url;
      }
    }